import { Testimonial } from './types'

const testimonials: Testimonial[] = [
  {
    name: 'Garrett Mann',
    avatar: '/images/landing/avatars/7.jpg',
    job: 'Security Pacific Real Estate',
    license: 'DRE# 02019705',
    testimonial:
      "TopHap is one of the most incredible tech and analytics tools in the entire real estate industry. I've personally been using TopHap since its beta version, and from day 1, I was thoroughly impressed by the features and data accessible at your fingertips. Not to mention the EXCEPTIONAL improvements and features that continue to be added and implemented. Not only is the actual technology amazing, but the team of people behind TopHap is just as amazing and extremely helpful. I wouldn't trade TopHap for anything, and I can't wait to see how this real estate technology continues to grow and exceed my expectations. Lastly, my clients LOVE the consumer-facing branded portal, and so do I!"
  },
  {
    name: 'Braxton A. Warren',
    avatar: '/images/landing/avatars/11.jpg',
    job: 'Warren Group Partners',
    license: 'DRE# 02088993',
    testimonial:
      'TopHap is everything I have been dreaming about. I crave systems, efficiency, and innovation. TopHap goes above and beyond anything I could have hoped for. The real estate industry in a general sense, is very behind in terms of technology. Tools and resources are limited and the ones available are outdated and inefficient. I have spent a considerable amount of time scouring the internet, calling different companies, sitting in on demonstrations, any and everything you could think of with the hope to locate a solution. TopHap is that solution and so much more.'
  },
  {
    name: 'Taylor Coyle',
    avatar: '/images/landing/avatars/10.jpg',
    job: 'NextHome LandCastle Luxury Real Estate',
    testimonial:
      'TopHap is truly a game changer for the industry. When working with a universal platform that offers endless data and possibilities on a property or region, you’ll become an expert in the area while saving an immense amount of time on research. From new construction opportunities to real-time analytics in any market place, TopHap gives all the insight you need to find or make your next big move in real estate. Job well done!'
  },
  {
    name: 'George El-Chemali',
    avatar: '/images/landing/avatars/8.jpg',
    job: 'Warren Group Partners',
    license: 'DRE# 02129952',
    testimonial:
      "TopHap is changing the real estate industry as we know it. Prior to coming across the platform, my biggest complaint was the outdated resources real estate agents have access to. I believe technology is a key component to maximizing efficiency and success as a business. TopHap's innovative drive alone drew my attention. The platform makes data analysis interactive, engaging, and presentable to all audiences. TopHap is the one-stop-shop for all real estate needs and will help take your market knowledge to the next level!"
  },
  {
    name: 'Scott Hoffman',
    avatar: '/images/landing/avatars/9.jpg',
    job: 'eXp Realty of California Inc',
    license: 'Lic # 02026536',
    testimonial:
      "TopHap allows me to give my clients expert advice based on the analytics in the software. It's nice to find all the information I need about an area on one platform. It saves me from having to go to various sites to extract information. I love how fast I was able to learn how to navigate within the software."
  },
  {
    name: 'Alex Michas',
    avatar: '/images/landing/avatars/13.jpg',
    job: "Golden Gate Sotheby's",
    license: 'CalBRE# 01942824',
    testimonial:
      'To those who are data-minded, TopHap can not be matched. As an agent selecting tools that support my business, TopHap is among my top three tech platforms. It shows another degree of market knowledge that enables me to translate information into a path forward for buyer and seller clients. Anton, his team, and TopHap make me a better agent.'
  },
  {
    name: 'Monica Rodgers',
    avatar: '/images/landing/avatars/12.jpg',
    job: 'eXp Realty of California Inc',
    testimonial:
      "Become a neighborhood expert in less time with this comprehensive, easy to use and visually appealing platform. TopHap will change the game for your real estate business and give you an advantage in today's competitive market. Thanks TopHap!"
  },
  {
    name: 'Herman Chan',
    avatar: '/images/landing/avatars/5.jpg',
    job: 'Golden Gate Sotheby’s International Realty',
    testimonial:
      'TopHap is my secret weapon. I wow my sellers during listing presentations. No one else is showing them this data in such an elegant way. Buyers are impressed I know the nuances of neighborhoods, which I looked up easily on TopHap. In this competitive market, every advantage helps.'
  },
  {
    avatar: '/images/landing/avatars/4.jpg',
    name: 'Stephanie Hauser',
    job: 'COMPASS',
    license: 'DRE# 01955633',
    testimonial:
      'I was introduced to TopHap by a colleague and it quickly became my favorite real estate platform. It has enhanced my interactions with both buyers and sellers by providing unparalleled analytics, data, maps and market research. There is SO MUCH you can do with TopHap but one of my favorite features is the 3D elevation map. I can’t recommend this platform enough—it’s a game changer in our industry and I am hooked!'
  },
  {
    name: 'Mark Milz',
    avatar: '/images/landing/avatars/6.jpg',
    job: 'President/CEO Milz Development',
    testimonial:
      'TopHap is changing the real estate investment game! This is a groundbreaking platform that has put all the tools in one place to accurately predict and evaluate real estate.'
  },
  {
    name: 'Jason Hoffman',
    avatar: '/images/landing/avatars/1.jpg',
    job: 'Luxury Property Specialist',
    testimonial:
      "I'm loving the program! I had a client looking for some upcoming new construction homes. Using TopHap, I was able to identify a bunch of upcoming projects. It's super cool and a game changer! Congrats on the recent success and I'm excited to be a part of your growth."
  },
  {
    name: 'Remy Weinstein',
    avatar: '/images/landing/avatars/2.jpg',
    job: "Golden Gate Sotheby's International Realty",
    testimonial:
      "I've used TopHap over the past few months and the possibilities are endless! The kind of tool every agent needs in today's technology and information driven world. Very affordable and easy to implement."
  },
  {
    avatar: '/images/landing/avatars/3.jpg',
    name: 'Josue Juarez',
    job: 'REeBroker Services',
    testimonial:
      'Truly thankful for the prolific TopHap platform, it provides up-to-date information from analytics, trends, to public records, not to mention the beautiful UI with a detailed visual design that makes navigating exciting.'
  }
]

export default testimonials
